/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_LedeInputs */

const tr_landing_referral_lede = /** @type {(inputs: Landing_Referral_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel kullanan her firma bir davet linkine sahip. Linkinizi paylaşın, arkadaşınız abone olduğunda ikiniz de 1 ay ücretsiz kullanın.`)
};

const en_landing_referral_lede = /** @type {(inputs: Landing_Referral_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every company on ShopPanel gets its own invite link. Share yours, and when your friend subscribes, you both get 1 month free.`)
};

const de_landing_referral_lede = /** @type {(inputs: Landing_Referral_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Firma, die ShopPanel nutzt, hat einen eigenen Einladungslink. Teilen Sie Ihren Link; sobald Ihr Freund ein Abo abschließt, nutzen Sie beide 1 Monat gratis.`)
};

const ru_landing_referral_lede = /** @type {(inputs: Landing_Referral_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У каждой компании в ShopPanel есть собственная пригласительная ссылка. Поделитесь ссылкой: когда друг оформит подписку, вы оба получите 1 месяц бесплатно.`)
};

/**
* | output |
* | --- |
* | "Every company on ShopPanel gets its own invite link. Share yours, and when your friend subscribes, you both get 1 month free." |
*
* @param {Landing_Referral_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_lede = /** @type {((inputs?: Landing_Referral_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_lede(inputs)
	if (locale === "de") return de_landing_referral_lede(inputs)
	if (locale === "ru") return ru_landing_referral_lede(inputs)
	return tr_landing_referral_lede(inputs)
});